const jobs = (state = [], action) => {
  if (action.response && action.response.job) {
    return [...state, ...action.response.job];
  }
  return state;
};

export default jobs;
